export default __webpack_public_path__ + "static/media/Editar.fce09122.svg";